import { pipe, map } from '../../utils.js';
import React, { useState, useEffect } from 'react';
import { getCoordinates } from "./getCoordinates.js";

const toCSSVars = f => pipe(
    Object.entries,
    map(([key, value]) => ['--' + key, f(value)]),
    Object.fromEntries
);

const px = x => x + 'px';

const Cursor = ({focus: {x, y}}) => 
    <div id="cursor-anchor">
        <div
            id="cursor"
            style={({transform: `translate(${x}px, ${y}px)`})}
        />
    </div>

const getName = e => e.target.alt;
const getNavWidth = () => document.querySelector('#portfolio nav').offsetWidth;
const getColumns = (navWidth, width) => Math.floor(navWidth/width) || 1;
const getMoveCursor = setFocus => (coords, getName) => pipe(getName, coords, setFocus);

export const Nav = ({ items, selected, clickHandler }) => {
    const width = 200;
    const height = 74;

    const [navWidth, setNavWidth] = useState(null);
    const columns = getColumns(navWidth, width);
    const coords = getCoordinates({ items, width, height, columns});
    const [focus, setFocus] = useState(coords(selected));

    const updateWidth = pipe(getNavWidth, setNavWidth);
    const moveCursor = getMoveCursor(setFocus);
    
    useEffect(updateWidth);

    window.onresize = (e) => {
        const newColumns = getColumns(getNavWidth(), width);

        if (newColumns !== columns) {
            updateWidth();
            const coords = getCoordinates({
                items, width, height, columns: newColumns
            })
            moveCursor(coords, () => selected)(e);
        }
    }

    const onClick = clickHandler(moveCursor(coords, getName));

    return <nav style={toCSSVars(px)({height, width})}>
        <Cursor focus={focus}/>
        {items.map((name, i) => 
            <NavItem 
                key={name} 
                name={name} 
                onClick={onClick(name)}
            />
        )}
    </nav>
}

const NavItem = ({ name, onClick }) => 
    <a onClick={onClick} href={`portfolio/${name}.html`}>
        <img  alt={name} className="logo" src={`logos/${name}.svg`}/>
    </a>
